import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { adapter } from "@/services/db";

export const HasTeamSwitch = ({ pro }) => {
  const [busy, setBusy] = useState(false);
  const [local, setLocal] = useState({});
  const on = local[pro.id] ?? (pro.has_team === true);
  const toggle = async (v) => {
    setBusy(true); setLocal((m) => ({ ...m, [pro.id]: v }));
    try { await adapter.update("professionals", pro.id, { has_team: v, updated_at: new Date().toISOString() }); toast.success(v ? "Marked as having a team" : "Marked as solo"); }
    catch (e) { setLocal((m) => ({ ...m, [pro.id]: undefined })); toast.error(e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-4 rounded-lg border border-border p-3 flex items-center justify-between" data-testid="pro-has-team-box">
      <div>
        <p className="text-sm font-medium text-foreground">Has a team</p>
        <p className="text-[11px] text-muted-foreground">Saved as has_team · only Command Centre staff can change it</p>
      </div>
      <Switch data-testid="pro-has-team-switch" checked={on} disabled={busy} onCheckedChange={toggle} />
    </div>
  );
};
